import React from 'react';
import { PropertyTypes } from './PropertyTypes';
import { ChildrenRegions } from './ChildrenRegions';
import { NeighbourRegions } from './NeighbourRegions';
export var SeoFooterContainer = function SeoFooterContainer(_ref) {
  var neighbourRegions = _ref.neighbourRegions,
    childrenRegions = _ref.childrenRegions,
    neighbourRegionType = _ref.neighbourRegionType,
    childrenRegionType = _ref.childrenRegionType,
    domain = _ref.domain,
    geoPathUri = _ref.geoPathUri;
  return /*#__PURE__*/React.createElement("div", {
    className: "background"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper padding-top-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex one-whole"
  }, /*#__PURE__*/React.createElement(ChildrenRegions, {
    regions: childrenRegions,
    regionType: childrenRegionType,
    domain: domain
  }), /*#__PURE__*/React.createElement(NeighbourRegions, {
    regions: neighbourRegions,
    regionType: neighbourRegionType,
    domain: domain
  }), /*#__PURE__*/React.createElement(PropertyTypes, {
    domain: domain,
    geoPathUri: geoPathUri
  }))));
};